// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IKWX","fullView":"styles_fullView__1MRX9"};